<ng-container>
  <div class="ppl-container-body">
    <div class="ppl-container-head gl-head">
      <div class="gl-head__titles">
        <nav class="gl-breadcrumb" aria-label="Breadcrumb">
          <a class="gl-breadcrumb__link" href="javascript:void(0)">Payments &amp; Deposits</a>
          <span class="gl-breadcrumb__sep" aria-hidden="true">›</span>
          <span class="gl-breadcrumb__current">Global Ledger</span>
        </nav>
        <h1 class="gl-title">Global Ledger</h1>
      </div>
    </div>

    <div class="ppl-container">
      <div class="ppl-content-container">

        @if (feedback) {
        <div class="gl-feedback" [class.gl-feedback--error]="feedbackIsError" role="status">{{ feedback }}</div>
        }

        <!-- ---------- TABS ---------- -->
        <div class="gl-tabs" role="tablist" aria-label="Global Ledger">
          <button type="button" class="gl-tab" role="tab" [attr.aria-selected]="activeTab === 'ledger'"
            (click)="showTab('ledger')">
            <i class="fa fa-list-alt" aria-hidden="true"></i> Ledger Entries
          </button>
          <button type="button" class="gl-tab" role="tab" [attr.aria-selected]="activeTab === 'approvals'"
            (click)="showTab('approvals')">
            <i class="fa fa-check-square-o" aria-hidden="true"></i> Write-off Approvals
          </button>
        </div>

        <!-- ===================== TAB 1 — LEDGER ENTRIES ===================== -->
        @if (activeTab === 'ledger') {
        <div role="tabpanel">

          <section class="gl-filter-card">
            <form (submit)="$event.preventDefault(); onSearch()" autocomplete="off">
              <div class="gl-filters">
                <div class="gl-filters__field">
                  <label for="dosFrom">DOS From</label>
                  <nz-date-picker id="dosFrom" [(ngModel)]="filterDosFrom" name="dosFrom" [nzFormat]="'MM/dd/yyyy'"
                    [nzPlaceHolder]="'From'" [class.gl-invalid]="searchError"></nz-date-picker>
                </div>
                <div class="gl-filters__field">
                  <label for="dosTo">DOS To</label>
                  <nz-date-picker id="dosTo" [(ngModel)]="filterDosTo" name="dosTo" [nzFormat]="'MM/dd/yyyy'"
                    [nzPlaceHolder]="'To'" [class.gl-invalid]="searchError"></nz-date-picker>
                </div>
                <div class="gl-filters__field">
                  <label for="fMco">MCO</label>
                  <ppl-dropdown-select id="fMco" [(ngModel)]="filterMco" name="fMco" [options]="mcoOptions"
                    placeholder="All MCOs"></ppl-dropdown-select>
                </div>
                <div class="gl-filters__field">
                  <label for="fIcn">Claim Number (PPL ICN)</label>
                  <input id="fIcn" type="text" [(ngModel)]="filterIcn" name="fIcn" placeholder="Search PPL ICN"
                    style="text-transform:uppercase" />
                </div>
                <div class="gl-filters__field">
                  <label for="fConsumer">Consumer PPL ID</label>
                  <input id="fConsumer" type="text" [(ngModel)]="filterConsumer" name="fConsumer"
                    placeholder="Search PPL ID" />
                </div>
                <button type="submit" class="gl-search-btn" aria-label="Search">
                  <i class="fa fa-search" aria-hidden="true"></i>
                </button>
                <button type="button" class="gl-link-btn" (click)="onClear()">Clear</button>
              </div>
              @if (searchError) {
              <div class="gl-filters-err" role="alert">{{ searchError }}</div>
              }
            </form>
          </section>

          <section class="gl-section">
            <div class="gl-sec-head">
              <h2 class="gl-sec-head__title">Ledger Entries</h2>
              <button type="button" class="gl-btn gl-btn--ghost" style="margin-left:auto"
                [disabled]="!results.length || exportSubmitting" (click)="exportResults()">
                <i class="fa fa-file-excel-o" aria-hidden="true"></i> Export to Excel
              </button>
            </div>
            <div class="gl-sec-body">
              @if (results.length) {
              <ppl-list-table
                [data]="results"
                [cols]="ledgerCols"
                [from]="'billing'"
                [disableSort]="true"
                [disableSearch]="true"
                [showCustomSearch]="false"
                [disableSelection]="true"
                [gridTitle]="false"
                [enableActions]="true"
                [buttonConfig]="ledgerButtonConfig"
                (gridAction)="onGridAction($event)"
                [pagination]="true"
                [rowsToDisplay]="20"
                [loadPage]="false"
                [tableScrollable]="true">
              </ppl-list-table>
              } @else {
              <p class="gl-empty">No ledger records match these filters.</p>
              }
            </div>
          </section>
        </div>
        }

        <!-- ===================== TAB 2 — WRITE-OFF APPROVALS ===================== -->
        @if (activeTab === 'approvals') {
        <div role="tabpanel">
          <section class="gl-section">
            <div class="gl-sec-head">
              <span class="gl-tag gl-tag--purple">Write-offs</span>
              <h2 class="gl-sec-head__title">Claim Write-off Requests</h2>
              <span class="gl-sec-head__sum">Approved write-offs post to the Ledger Entries tab</span>
            </div>
            <div class="gl-sec-body">
              <div class="gl-toolbar">
                <div class="gl-seg" role="group" aria-label="Request status">
                  @for (s of ['Pending', 'Approved', 'Rejected', 'All']; track s) {
                  <button type="button" [attr.aria-pressed]="apStatus === s" (click)="setApStatus($any(s))">{{ s }}</button>
                  }
                </div>
                <div class="gl-filters__field" style="min-width:240px">
                  <label for="apSearch">Search</label>
                  <input id="apSearch" type="text" [(ngModel)]="apSearch" name="apSearch"
                    placeholder="PPL ICN or PPL ID" (ngModelChange)="onApSearch()" />
                </div>
                <div class="gl-filters__field" style="min-width:200px">
                  <label for="apMco">MCO</label>
                  <ppl-dropdown-select id="apMco" [(ngModel)]="apMco" name="apMco" [options]="mcoOptions"
                    placeholder="All MCOs"></ppl-dropdown-select>
                </div>
                @if (apStatus === 'Pending') {
                <div class="gl-row-actions" style="margin-left:auto">
                  <button type="button" class="gl-btn gl-btn--primary" [disabled]="!selectedIds.size"
                    (click)="openApproveConfirm(selectedIdsArray)">
                    <i class="fa fa-check" aria-hidden="true"></i> Approve Selected
                    @if (selectedIds.size) { ({{ selectedIds.size }}) }
                  </button>
                  <button type="button" class="gl-btn gl-btn--danger" [disabled]="!selectedIds.size"
                    (click)="openRejectConfirm(selectedIdsArray)">
                    <i class="fa fa-times" aria-hidden="true"></i> Reject Selected
                    @if (selectedIds.size) { ({{ selectedIds.size }}) }
                  </button>
                </div>
                }
              </div>

              @if (filteredRequests.length) {
              <div class="gl-tbl-scroll">
                <table class="gl-table">
                  <thead>
                    <tr>
                      @if (apStatus === 'Pending') {
                      <th class="gl-ctr">
                        <input type="checkbox" aria-label="Select all" [checked]="allSelectedOnPage"
                          [disabled]="!filteredRequests.length" (change)="selectAllOnPage($any($event.target).checked)" />
                      </th>
                      }
                      <th>PPL ICN</th><th>Consumer</th><th>MCO</th><th>Date of Service</th>
                      <th class="gl-num">Total Charges</th><th class="gl-num">Payments</th>
                      <th class="gl-num">AR Amount</th><th class="gl-num">Write-off Amount</th>
                      <th>Reason</th><th>Requested By</th><th>Request Date</th>
                      <th>Decision</th><th>Comment</th><th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (r of filteredRequests; track r.id) {
                    <tr>
                      @if (apStatus === 'Pending') {
                      <td class="gl-ctr">
                        <input type="checkbox" [attr.aria-label]="'Select ' + r.id" [checked]="isSelected(r.id)"
                          (change)="toggleSelect(r.id, $any($event.target).checked)" />
                      </td>
                      }
                      <td class="gl-mono">{{ r.pplIcn }}</td>
                      <td class="gl-nowrap">
                        @if (r.consumerName !== '-') { {{ r.consumerName }}<span class="gl-sub-note">{{ r.pplId }}</span> }
                        @else { {{ r.pplId }} }
                      </td>
                      <td class="gl-nowrap">{{ r.mco }}</td>
                      <td>{{ r.dos | date: 'MM/dd/yyyy' }}</td>
                      <td class="gl-num">{{ formatCurrency(r.totalCharges) }}</td>
                      <td class="gl-num">{{ formatCurrency(r.payments) }}</td>
                      <td class="gl-num">{{ formatCurrency(r.arAmount) }}</td>
                      <td class="gl-num"><b>{{ formatCurrency(r.writeOffAmount) }}</b></td>
                      <td style="min-width:200px">{{ r.reason }}</td>
                      <td class="gl-nowrap">{{ r.requestedBy }}</td>
                      <td class="gl-nowrap">{{ r.requestedOn | date: 'MM/dd/yyyy' }}</td>
                      <td class="gl-nowrap">
                        <span [ngClass]="r.status === 'Approved' ? 'gl-pill gl-pill--ok' : r.status === 'Rejected' ? 'gl-pill gl-pill--err' : 'gl-pill gl-pill--none'">{{ r.status }}</span>
                        @if (r.status !== 'Pending') {
                        <span class="gl-sub-note">{{ r.decidedBy }} · {{ r.decidedOn | date: 'MM/dd/yyyy' }}</span>
                        }
                      </td>
                      <td style="min-width:180px">{{ r.comment || '—' }}</td>
                      <td>
                        <div class="gl-row-actions">
                          <button type="button" class="gl-btn-row gl-btn-row--ok" [disabled]="!canDecide(r)"
                            [title]="canDecide(r) ? '' : 'You raised this request — another approver must decide it'"
                            (click)="openApproveConfirm([r.id])">✔ Approve</button>
                          <button type="button" class="gl-btn-row gl-btn-row--no" [disabled]="!canDecide(r)"
                            [title]="canDecide(r) ? '' : 'You raised this request — another approver must decide it'"
                            (click)="openRejectConfirm([r.id])">✘ Reject</button>
                        </div>
                      </td>
                    </tr>
                    }
                  </tbody>
                </table>
              </div>
              } @else {
              <p class="gl-empty">No write-off requests match the current filters.</p>
              }
            </div>
          </section>
        </div>
        }

      </div>
    </div>
  </div>

  <!-- ---------- Write Off request modal (Ledger Entries) ---------- -->
  <ppl-popup-dialog [(isVisible)]="showWriteOffModal" title="Write Off Claim"
    [showClose]="true" [showButtons]="true" [showOkButton]="false"
    isOkText="Submit Request" [showButtonIcons]="false" [okDisabled]="woSubmitting"
    [rightAlignedButtons]="true" size="medium" position="top"
    (cancel)="closeWriteOff()" (confirm)="submitWriteOff()">
    @if (woRow) {
    <div class="gl-kv">
      <div><span class="gl-kv__k">PPL ICN</span><span class="gl-kv__v gl-mono">{{ woRow.pplIcn }}</span></div>
      <div><span class="gl-kv__k">Consumer</span><span class="gl-kv__v">{{ woRow.consumerDisplay }}</span></div>
      <div><span class="gl-kv__k">MCO</span><span class="gl-kv__v">{{ woRow.mco }}</span></div>
      <div><span class="gl-kv__k">Date of Service</span><span class="gl-kv__v">{{ woRow.eventDate | date: 'MM/dd/yyyy' }}</span></div>
      <div><span class="gl-kv__k">Total Charges</span><span class="gl-kv__v">{{ formatCurrency(woRow.charges ?? 0) }}</span></div>
      <div><span class="gl-kv__k">Payments</span><span class="gl-kv__v">{{ formatCurrency(woRow.payments ?? 0) }}</span></div>
      <div><span class="gl-kv__k">Write-off Amount</span><span class="gl-kv__v"><b>{{ formatCurrency(woRow.openBal ?? 0) }}</b></span></div>
    </div>
    <div class="gl-field" style="margin-bottom:12px">
      <label for="woReason">Reason *</label>
      <ppl-dropdown-select id="woReason" [(ngModel)]="woReason" name="woReason" [options]="woReasonOptions"
        placeholder="Select a reason"></ppl-dropdown-select>
      <div class="gl-err" role="alert">{{ woReasonError }}</div>
    </div>
    <div class="gl-field">
      <label for="woComment">Comments (optional)</label>
      <textarea id="woComment" [(ngModel)]="woComment" name="woComment"
        placeholder="Add any detail for the approver"></textarea>
    </div>
    <p class="gl-hint">The full open balance is written off. The request goes to Write-off Approvals and the claim
      shows W/O pending until it is approved.</p>
    @if (woSubmitError) {
    <div class="gl-err" role="alert">{{ woSubmitError }}</div>
    }
    }
  </ppl-popup-dialog>

  <!-- ---------- Approve/Reject confirmation (Write-off Approvals) ---------- -->
  <ppl-popup-dialog [(isVisible)]="showConfirmModal" [title]="confirmAction === 'Approved' ? 'Confirm Write-off' : 'Reject Writeoffs'"
    [showClose]="false" [showButtons]="true" [showOkButton]="false"
    [isOkText]="confirmAction === 'Approved' ? 'Approve' : 'Reject'" [showButtonIcons]="false"
    [okDisabled]="confirmSubmitting || (confirmAction === 'Rejected' && !confirmComment.trim())"
    [rightAlignedButtons]="true" size="medium" position="top"
    (cancel)="closeConfirm()" (confirm)="commitDecision()">
    <p style="margin:0 0 12px">{{ confirmMessage }}</p>
    <div class="gl-field">
      <label for="confirmComment">Comments{{ confirmAction === 'Rejected' ? ' *' : ' (optional)' }}</label>
      <textarea id="confirmComment" [(ngModel)]="confirmComment" name="confirmComment"
        placeholder="Add any detail for the record"></textarea>
      <div class="gl-err" role="alert">{{ confirmCommentError }}</div>
    </div>
    @if (confirmError) {
    <div class="gl-err" role="alert">{{ confirmError }}</div>
    }
  </ppl-popup-dialog>
</ng-container>
